import React, { useEffect } from "react";
import { CURRENT_COUNTRY, REVIEWS_STORE } from "utils/constants";
import insertScript from "helpers/insert-script";
import { useGlobalContext } from "context/global";

const FloatingReviewsWidget = ({ data }) => {
	const { show } = data;
	const { language } = useGlobalContext();
	const currentLang = language === "default" ? CURRENT_COUNTRY : language;

	useEffect(() => {
		insertScript("body", "//widget.reviews.io/modern-widgets/floating.js", "reviews-io-embed", true, true);
	}, []);

	return (
		show && <div className="reviews-io-floating-widget" data-widget-id="sa1mfHIvL5uVUlED"
			data-store-name={REVIEWS_STORE} lang={currentLang}></div>
	);
};

export default FloatingReviewsWidget;
